export default __webpack_public_path__ + "static/media/paytm.7b3abc68.svg";